export function ApplyViaOttaDark(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.5689 16.1323L29.195 15.5063L27.3166 13.6284L23.8754 10.1884L21.9969 8.31057L21.3707 8.93653L20.1184 10.1884L9.08016 21.223C8.50387 21.7991 8.08273 22.5137 7.85 23.2948L5.88838 29.9643C5.74985 30.4296 5.8773 30.9337 6.2264 31.2771C6.5755 31.6206 7.07422 31.748 7.53968 31.615L14.2059 29.6541C14.9872 29.4214 15.702 29.0004 16.2783 28.4243L27.3166 17.3897L28.5689 16.1323ZM14.699 25.4607L14.1948 26.7182C13.9731 26.8899 13.7238 27.0173 13.4578 27.1004L9.12449 28.3745L10.399 24.0481C10.4766 23.7767 10.6096 23.5274 10.7813 23.3114L12.0392 22.8073V24.5799C12.0392 25.0674 12.4382 25.4662 12.9258 25.4662H14.699V25.4607ZM25.9312 4.37202L25.1333 5.17524L23.8809 6.42716L23.2492 7.05311L25.1277 8.93099L28.5689 12.371L30.4474 14.2489L31.0735 13.6229L32.3259 12.371L33.1294 11.5678C34.5147 10.1829 34.5147 7.93943 33.1294 6.55456L30.9516 4.37202C29.5663 2.98716 27.3221 2.98716 25.9368 4.37202H25.9312ZM23.3047 13.6783L15.3252 21.6551C14.9816 21.9985 14.4164 21.9985 14.0729 21.6551C13.7293 21.3117 13.7293 20.7466 14.0729 20.4032L22.0523 12.4264C22.3959 12.0829 22.9611 12.0829 23.3047 12.4264C23.6482 12.7698 23.6482 13.3348 23.3047 13.6783Z"
        fill="black"
      />
      <path
        d="M5.83325 35.4167C5.83325 34.724 6.39054 34.1667 7.08325 34.1667H32.9166C33.6093 34.1667 34.1666 34.724 34.1666 35.4167C34.1666 36.1094 33.6093 36.6667 32.9166 36.6667H7.08325C6.39054 36.6667 5.83325 36.1094 5.83325 35.4167Z"
        fill="black"
      />
    </svg>
  );
}
